import PropTypes from 'prop-types';
import ImageIcon from '@mui/icons-material/Image';
import DataObjectIcon from '@mui/icons-material/DataObject';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Stack from '@mui/material/Stack';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useCallback, useEffect, useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';
import XIcon from '@untitled-ui/icons-react/build/esm/X';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import CheckIcon from '@mui/icons-material/Check';
import { resolveSrc } from '../../../../api/endpoints';
import SlowMotionVideoIcon from '@mui/icons-material/SlowMotionVideo';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import {
  playlistContentSorting,
  syncPlaylistSettings,
  updateDuration,
  updatePlaylistOptions,
} from 'src/redux/actions/Playlist';
import { useTranslation } from 'react-i18next';
import { Refresh } from '@mui/icons-material';
import SettingsIcon from '@mui/icons-material/Settings';
import { Checkbox, Chip, CircularProgress, ListItemButton, MenuItem, Select, Switch } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import toast from 'react-hot-toast';

const statusMap = {
  canceled: 'warning',
  complete: 'success',
  pending: 'info',
  rejected: 'error',
};

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const OrderDetails = (props) => {
  const {
    onApprove,
    onReject,
    onSelectFiles,
    order,
    isEditing,
    handleEditOpen,
    handleDelete,
    saveDurationChange,
    deleteContentFromPlaylist,
    onSync,
    enableEdit,
    changesObserver,
    setChangesObserver,
    setPlaylistOptionsSync
  } = props;

  const { t } = useTranslation();

  const [duration, setDuration] = useState('');
  const [isEditingFile, setIsEditingFile] = useState(null);
  const [editingDuration, setEditingDuration] = useState(0);
  const [openOptionsPanel, setOpenOptionsPanel] = useState(false);
  const [playlistOptions, setPlaylistOptions] = useState({
    scale_image: 'Fit',
    scale_video: 'Fit',
    scale_document: 'Fit',
    shuffle: false,
    default_transition: 'None',
    transition_speed: 'Medium',
  });
  const dispatch = useDispatch();

  const [orderCopy, setOrderCopy] = useState(null);

  useEffect(() => {
    console.log(order._id)
    if (order) {
        setOrderCopy(JSON.parse(JSON.stringify(order)));
    }
    console.log('Order copy refresh')
  }, [order._id, dispatch]);

  const durationInputRef = useRef(null)

  const [durationEditElements, setDurationEditElements] = useState([])

  useEffect(() => {
    console.log(order)
  }, [order])

  useEffect(() => {
    if (order.playlistOptions) {
      setPlaylistOptions({
        scale_image: order?.playlistOptions?.scale_image,
        scale_video: order?.playlistOptions?.scale_video,
        scale_document: order?.playlistOptions?.scale_document,
        shuffle: order?.playlistOptions?.shuffle,
        default_transition: order?.playlistOptions?.default_transition,
        transition_speed: order?.playlistOptions?.transition_speed,
      });
    }

    if (orderCopy) {
        const newContent = order?.content.filter(c => orderCopy?.content.find(cnt => cnt._id == c._id) ? false : true)
        if (newContent) {
            setOrderCopy({...orderCopy, content: [...orderCopy.content, ...newContent]})
        }
    }

  }, [order]);

  const scaleOptions = [
    {
      id: 'Fit',
      default: true,
    },
    {
      id: 'Stretch',
      default: false,
    },
    {
      id: 'Zoom',
      default: false,
    },
  ];

  const transitionOptions = [
    {
      id: 'Fade',
      default: false,
    },
    {
      id: 'Slide from left',
      default: false,
    },
    {
      id: 'Slide from right',
      default: false,
    },
    {
      id: 'Rotate in',
      default: false,
    },
    {
      id: 'Flip',
      default: false,
    },
    {
      id: 'Gallery',
      default: false,
    },
    {
      id: 'None',
      default: true,
    },
  ];

  const transitionSpeedOptions = [
    {
      id: 'Slow',
      custom: false,
      default: false,
    },
    {
      id: 'Medium',
      custom: false,
      default: true,
    },
    {
      id: 'Fast',
      custom: false,
      default: false,
    },
    // {
    //   id: 'Custom',
    //   custom: true,
    //   default: false
    // }
  ];

  const handleBulkDurationEdit = () => {
    if (duration && /^[0-9]*$/.test(duration)) {
        durationEditElements.forEach(el => {
            handleDurationChangeEnd(null, el, duration)
        })
        setDurationEditElements([])
        setDuration('')
    } else {
        toast.error("Invalid duration value")
    }
  }

  const handleDurationChangeEnd = useCallback(
    async (e, id, bulkModeDuration=null) => {
        console.log(e, id, bulkModeDuration)
      e?.preventDefault();
      console.log('handleDurationChangeEnd - before update', {
        id,
        duration: bulkModeDuration ? bulkModeDuration : editingDuration,
      });

      console.log(orderCopy)

      if (bulkModeDuration ? true : (editingDuration !== 0 && !isNaN(editingDuration))) {
        await dispatch(
          updateDuration({
            time: bulkModeDuration ? bulkModeDuration : editingDuration,
            playlistId: order._id,
            contentId: id,
            resetDuration: false,
          }),
        );

        if (
            bulkModeDuration ? 
            (
                          orderCopy.content
            .map((c) => {
              return {
                duration: Number(c.duration) / 1000,
                id: c._id,
              };
            })
            .find((item) => item.id == id)?.duration == bulkModeDuration ? true : false
            ) : (
          orderCopy.content
            .map((c) => {
              return {
                duration: Number(c.duration) / 1000,
                id: c._id,
              };
            })
            .find((item) => item.id == id)?.duration == editingDuration ? true : false)
        ) {
          setChangesObserver((prev) => [
            ...prev.filter((item) =>
              item.type == 'durationChange'
                ? item.change.contentId == id
                  ? false
                  : true
                : true,
            ),
          ]);
        } else {
          setChangesObserver((prev) => [
            ...prev,
            {
              type: 'durationChange',
              change: {
                time: bulkModeDuration ? bulkModeDuration : editingDuration,
                playlistId: order._id,
                contentId: id,
                resetDuration: false,
              },
            },
          ]);
        }
      }
      setIsEditingFile(null);
      setEditingDuration(0);
    },
    [dispatch, editingDuration, order._id, orderCopy],
  );

  const handleResetDuration = useCallback(
    async (e, id) => {
      e.preventDefault();
      const item = order.content.find((item) => item._id === id);
      if (item && item.content) {
        const originalDuration = parseInt(item.content.duration, 10) / 1000;
        console.log(
          'handleResetDuration - original duration',
          originalDuration,
        );
        await dispatch(
          updateDuration({
            time: originalDuration,
            playlistId: order._id,
            contentId: id,
            resetDuration: true,
          }),
        );
        if (
          orderCopy.content
            .map((c) => {
              return {
                duration: Number(c.duration) / 1000,
                id: c._id,
              };
            })
            .find((item) => item.id == id)?.duration == originalDuration
        ) {
          setChangesObserver((prev) => [
            ...prev.filter((item) =>
              item.type == 'durationChange'
                ? item.change.contentId !== id
                  ? false
                  : true
                : true,
            ),
          ]);
        } else {
          setChangesObserver((prev) => [
            ...prev,
            {
              type: 'durationChange',
              change: {
                time: originalDuration,
                playlistId: order._id,
                contentId: id,
                resetDuration: false,
              },
            },
          ]);
        }
      }
      setIsEditingFile(null);
      setEditingDuration(0);
    },
    [dispatch, order],
  );

  const handleIsEditing = useCallback((item) => {
    const durationInSeconds = parseInt(item.duration, 10) / 1000;
    setEditingDuration(durationInSeconds);
    setIsEditingFile(item._id);
  }, []);

  const renderDuration = useCallback((duration) => {
    const durationInSeconds = parseInt(duration, 10) / 1000;
    return isNaN(durationInSeconds) ? '0s' : `${durationInSeconds.toFixed(0)}s`;
  }, []);

  const handleUpdatePlaylistOptions = (e) => {
    e.preventDefault();
    setOpenOptionsPanel(false);
    // dispatch(updatePlaylistOptions(order._id, playlistOptions))
    setChangesObserver((prev) => [
      ...prev.filter((c) => c.type !== 'playlistOptionsChange'),
      {
        type: 'playlistOptionsChange',
        change: [order._id, playlistOptions],
      },
    ]);
  };

  // const SPACE = { keyCode: 32 };
  // const ARROW_DOWN = { keyCode: 40 };
  // fireEvent.keyDown(element, SPACE);
  // fireEvent.keyDown(element, ARROW_DOWN);
  // fireEvent.keyDown(element, SPACE);

  useEffect(() => {
    // if (order.playlistOptions) {
    const playlistOptionsCopy = {
      scale_image: order?.playlistOptions?.scale_image || scaleOptions[0].id,
      scale_video: order?.playlistOptions?.scale_video || scaleOptions[0].id,
      scale_document:
        order?.playlistOptions?.scale_document || scaleOptions[0].id,
      shuffle: order?.playlistOptions?.shuffle || false,
      default_transition:
        order?.playlistOptions?.default_transition ||
        transitionOptions.find((o) => o.default).id,
      transition_speed:
        order?.playlistOptions?.transition_speed ||
        transitionSpeedOptions.find((o) => o.default).id,
    };
    if (
      JSON.stringify(Object.values(playlistOptionsCopy)) !==
      JSON.stringify(Object.values(playlistOptions))
    ) {
      setChangesObserver((prev) => [
        ...prev.filter((c) => c.type !== 'playlistOptionsChange'),
        {
          type: 'playlistOptionsChange',
          change: [order._id, playlistOptions],
        },
      ]);
      console.log(
        'change',
        JSON.stringify(Object.values(playlistOptionsCopy)),
        JSON.stringify(Object.values(playlistOptions)),
      );
    } else {
      setChangesObserver((prev) => [
        ...prev.filter((c) => c.type !== 'playlistOptionsChange'),
      ]);
      console.log('nochange');
    }
    // }
    setPlaylistOptionsSync(playlistOptions)
  }, [playlistOptions, order]);

  const dragHandler = (result) => {
    // Check if the drop was successful
    if (!result.destination) {
      return;
    }

    // Update the order of items based on the drag and drop result

    const reorderedList = Array.from(order.content);
    const [movedItem] = reorderedList.splice(result.source.index, 1);
    reorderedList.splice(result.destination.index, 0, movedItem);

    // Do not assign to order.content: the reducer performs the reorder, and mutating
    // the store object here would make it apply the move twice.

    // Update your component state or dispatch an action to update the order
    // setChangesObserver([...changesObserver, {
    //     type: "orderChange",
    //     change: [order._id, result.source.index, result.destination.index]
    // }])

    // const updatedChanges = [...changesObserver, {
    //     type: "orderChange",
    //     change: [order._id, result.source.index, result.destination.index]
    // }].filter((c) => c.type == 'orderChange' ? (
    //     // changesObserver.filter(cd => cd.type == 'orderChange')?.change[1] == changesObserver.filter(cd => cd.type == 'orderChange')[changesObserver.filter(cd => cd.type == 'orderChange').length-1][2] ? false : true
    //     order.content[c?.change[1]]._id == orderCopy.content[c?.change[2]]._id ? false : true
    // ) : true)

    const isChanged = reorderedList.filter((c, index) => {
      return orderCopy?.content?.[index]?._id != c._id ? true : false;
    });

    // console.log(first)

    console.log(isChanged);

    if (isChanged?.length > 0) {
      console.log('ok');
      setChangesObserver((prev) => [
        ...prev.filter((change) => change.type !== 'orderChange'),
        {
          type: 'orderChange',
          change: reorderedList.map((c) => c._id),
        },
      ]);
    } else {
      console.log('not ok');
      setChangesObserver((prev) => [
        ...prev.filter((change) => change.type !== 'orderChange'),
      ]);
    }

    // console.log([...changesObserver, {
    //     type: "orderChange",
    //     change: [order._id, result.source.index, result.destination.index]
    // }].forEach(el => console.log(order.content[el?.change[2]]._id, el?.change[0])))

    // console.log(updatedChanges)

    // setChangesObserver(updatedChanges)

    dispatch(
      playlistContentSorting(
        order._id,
        result.source.index,
        result.destination.index,
      ),
    );
  };

  useEffect(() => {
    console.log(changesObserver);
  }, [changesObserver]);

  const checboxLabelProps = { slotProps: { input: { 'aria-label': 'Duration edit checkbox' } } };

  return (
    <>
      <Stack spacing={6}>
        <Divider />
        <Stack spacing={3}>
          {!openOptionsPanel ? (
            <Stack
              alignItems='center'
              direction='row'
              spacing={1}
              justifyContent='space-between'
            >
              <Typography variant='h6'>
                {t('views.orderDetails.filesTitle')}
              </Typography>
              {enableEdit && (
                <Box
                  sx={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    startIcon={<SettingsIcon />}
                    onClick={() => setOpenOptionsPanel(true)}
                  >
                    {t('views.orderDetails.options')}
                  </Button>
                  <Button
                    onClick={onSelectFiles}
                    startIcon={
                      <SvgIcon>
                        <AddIcon />
                      </SvgIcon>
                    }
                    variant='contained'
                    size='small'
                  >
                    {t('views.orderDetails.addButton')}
                  </Button>
                  <Button
                    onClick={handleEditOpen}
                    size='small'
                    variant='contained'
                  >
                    {t('views.orderDetails.editButton')}
                  </Button>
                  <Button
                    color='error'
                    onClick={handleDelete}
                    size='small'
                    variant='outlined'
                  >
                    {t('views.orderDetails.deleteButton')}
                  </Button>
                </Box>
              )}
            </Stack>
          ) : null}

          {openOptionsPanel ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <List>
                <ListItem
                  sx={{ p: 0 }}
                  secondaryAction={
                    <IconButton onClick={() => setOpenOptionsPanel(false)}>
                      <CloseIcon />
                    </IconButton>
                  }
                >
                  <ListItemIcon>
                    <SettingsIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t('views.orderDetails.playlistOptions')}
                  />
                </ListItem>
              </List>
              <Box
                component='form'
                onSubmit={(e) => handleUpdatePlaylistOptions(e)}
              >
                <table
                  style={{
                    width: '95%',
                  }}
                >
                  <tr>
                    <td
                      style={{
                        width: '150px',
                      }}
                    >
                      <Typography my={3}>
                        {t('views.orderDetails.scaleImage')}
                      </Typography>
                    </td>
                    <td>
                      <Select
                        sx={{
                          ml: 2,
                          width: '100%',
                        }}
                        value={playlistOptions.scale_image}
                        id='scaleImageSelect'
                        onChange={(e) =>
                          setPlaylistOptions({
                            ...playlistOptions,
                            scale_image: e.target.value,
                          })
                        }
                      >
                        {scaleOptions.map((o, index) => {
                          return (
                            <MenuItem key={index} value={o.id}>
                              {o.id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography my={3}>
                        {t('views.orderDetails.scaleVideo')}
                      </Typography>
                    </td>
                    <td>
                      <Select
                        sx={{
                          ml: 2,
                          width: '100%',
                        }}
                        value={playlistOptions.scale_video}
                        id='scaleVideoSelect'
                        onChange={(e) =>
                          setPlaylistOptions({
                            ...playlistOptions,
                            scale_video: e.target.value,
                          })
                        }
                      >
                        {scaleOptions.filter(o => o.id !== 'Stretch').map((o, index) => {
                          return (
                            <MenuItem key={index} value={o.id}>
                              {o.id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </td>
                  </tr>
                  {/* <tr>
                    <td>
                      <Typography>Scale Document</Typography>
                    </td>
                    <td>
                      <Select value={scaleOptions.find(o => o.default).id} id="scaleDocumentSelect">
                        {scaleOptions.map((o, index) => {
                          return (
                            <MenuItem key={index} value={o.id} >{o.id}</MenuItem>
                          )
                        })}
                      </Select>  
                    </td>
                  </tr> */}
                  <tr>
                    <td>
                      <Typography my={3}>
                        {t('views.orderDetails.shuffle')}
                      </Typography>
                    </td>
                    <td>
                      <Switch
                        checked={playlistOptions.shuffle}
                        onChange={(e) =>
                          setPlaylistOptions({
                            ...playlistOptions,
                            shuffle: e.target.checked,
                          })
                        }
                        sx={{
                          ml: 2,
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography my={3}>
                        {t('views.orderDetails.transition')}
                      </Typography>
                    </td>
                    <td>
                      <Select
                        sx={{
                          ml: 2,
                          width: '100%',
                        }}
                        value={playlistOptions.default_transition}
                        onChange={(e) =>
                          setPlaylistOptions({
                            ...playlistOptions,
                            default_transition: e.target.value,
                          })
                        }
                        id='transitionSelect'
                      >
                        {transitionOptions.map((o, index) => {
                          return (
                            <MenuItem key={index} value={o.id}>
                              {o.id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography my={3}>
                        {t('views.orderDetails.transitionSpeed')}
                      </Typography>
                    </td>
                    <td>
                      <Select
                        sx={{
                          ml: 2,
                          width: '100%',
                        }}
                        value={playlistOptions.transition_speed}
                        onChange={(e) =>
                          setPlaylistOptions({
                            ...playlistOptions,
                            transition_speed: e.target.value,
                          })
                        }
                        id='transitionSpeedSelect'
                      >
                        {transitionSpeedOptions.map((o, index) => {
                          return (
                            <MenuItem key={index} value={o.id}>
                              {o.id}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </td>
                  </tr>
                </table>
                <Typography variant='subtitle1' mt={2} color='warning.main'>
                  {t('views.orderDetails.transitionsInfo')}
                </Typography>
                {/* <Button variant="contained" type="submit" sx={{
                  mt: 3
                }}>{t("views.addPlaylistModal.saveButton")}</Button> */}
              </Box>
            </Box>
          ) : (
            <>
            {durationEditElements.length > 0 && (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px"
                }}>
                    <Checkbox checked={durationEditElements.length == order?.content.length} onChange={e => e.target.checked ? setDurationEditElements(order?.content.map(c => c._id)) : setDurationEditElements([])} />
                                            <TextField
                                                focused
                                                label={t(
                                                'views.orderDetails.durationLabel',
                                                )}
                                                fullWidth
                                                type='number'
                                                autoComplete='off'
                                                value={duration}
                                                onInput={e => setDuration(e.target.value)}
                                                onKeyDown={(e) => {
                                                  if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleBulkDurationEdit();
                                                  }
                                                }}
                                                placeholder='10s'
                                                inputProps={{ min: 0, step: 1 }}
                                                sx={{ maxWidth: '100px' }}
                                                size="small"
                                            />   
                    <Box>
                        <Tooltip title="Click to edit duration for all checked files">
                            <div onClick={handleBulkDurationEdit} style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                                backgroundColor: "#2970FF",
                                padding: "5px 10px",
                                borderRadius: "50px",
                                fontSize: "15px"
                            }}>
                                Edit
                                <Edit02Icon />
                                {/* <Chip label={`Edit`} color='primary' deleteIcon={<Edit02Icon />} onDelete={() => {}} /> */}
                            </div>
                        </Tooltip>
                    </Box>                                                     
                </Box>
            )} 
            <DragDropContext onDragEnd={dragHandler}>
              <Droppable droppableId='fileList'>
                {(provided, snapshot) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    <List>
                      {order?.content
                        ?.filter(function (item) {
                          if (item.content) {
                            return true;
                          }
                          return false;
                        })
                        .map((item, index) => item?.type == 'addPlaceholder' ? (
                            <>
                                <ListItem
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    '& + &': {
                                      mt: 1,
                                    },
                                    margin: '5px 0',
                                    p: 3
                                  }}
                                >
                                    <CircularProgress size={20} />
                                    <Typography sx={{
                                        ml: 3
                                    }}>Loading...</Typography>
                                </ListItem>                            
                            </>
                        ) : (
                          <Draggable
                            key={item._id}
                            draggableId={item._id}
                            index={index}
                            isDragDisabled={!enableEdit}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{ ...provided.draggableProps.style, padding: '5px 0' }}
                              >
                                <ListItem
                                  sx={{
                                    border: 1,
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    '& + &': {
                                      mt: 1,
                                    },
                                    margin: 0,
                                  }}
                                >
                                  <Checkbox {...checboxLabelProps} checked={durationEditElements.includes(item._id) ? true : false} onChange={e => setDurationEditElements((prev) => e.target.checked ? [...prev, item._id] : [...prev.filter(x => x !== item._id)])}  />  
                                  <Box
                                    sx={{
                                      height: '60px',
                                      width: '100px',
                                      marginRight: '20px',
                                    }}
                                  >                                  
                                    {item?.content?.type === 'image' && (
                                      <img
                                        src={resolveSrc(item?.content?.url)}
                                        style={{
                                          height: '95%',
                                          width: '80%',
                                          objectFit: 'contain',
                                        }}
                                      />
                                    )}
                                    {(item?.content?.type === 'widget' ||
                                      item?.content?.type ===
                                        'split_screen') && (
                                      <img
                                        src={`${item?.content?.widget?.widgetIcon}`}
                                        style={{
                                          height: '95%',
                                          width: '80%',
                                          objectFit: 'contain',
                                        }}
                                      />
                                    )}
                                    {item?.content?.type === 'video' && (
                                      <video
                                        src={resolveSrc(item?.content?.url)}
                                        style={{
                                          height: '95%',
                                          width: '80%',
                                          objectFit: 'contain',
                                        }}
                                      />
                                    )}
                                    {item?.content?.embed === 'embed' && (
                                      <embed
                                        src={`${item?.content?.url}`}
                                        style={{
                                          height: '95%',
                                          width: '80%',
                                          objectFit: 'contain',
                                        }}
                                      />
                                    )}
                                  </Box>
                                  <ListItemIcon>
                                    {item?.content?.type === 'image' && (
                                      <ImageIcon />
                                    )}
                                    {item?.content?.type === 'widget' && (
                                      <AppRegistrationIcon />
                                    )}
                                    {item?.content?.type === 'video' && (
                                      <SlowMotionVideoIcon />
                                    )}
                                    {item?.content?.type === 'embed' && (
                                      <AppRegistrationIcon />
                                    )}
                                    {!(
                                      item?.content?.type === 'image' ||
                                      item?.content?.type === 'widget' ||
                                      item?.content?.type === 'video' ||
                                      item?.content?.type === 'embed'
                                    ) && <AppRegistrationIcon />}
                                  </ListItemIcon>
                                  <Tooltip
                                    title={
                                      item?.content?.name?.length > 30
                                        ? item?.content?.name
                                        : ''
                                    }
                                    placement='right'
                                  >
                                    <ListItemText
                                      primary={
                                        item?.content?.name?.length > 30
                                          ? `${item?.content?.name.slice(0, 30)}...`
                                          : item?.content?.name
                                      }
                                      primaryTypographyProps={{
                                        variant: 'subtitle2',
                                      }}
                                      sx={{
                                        maxWidth: 'calc( 100% - 140px )',
                                        overflowWrap: 'break-word;',
                                      }}
                                    />
                                  </Tooltip>
                                  {isEditingFile === item._id ? (
                                    <Box
                                      component='form'
                                      onSubmit={(e) =>
                                        handleDurationChangeEnd(e, item._id)
                                      }
                                      onReset={(e) =>
                                        handleResetDuration(e, item._id)
                                      }
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <TextField
                                        disabled={!enableEdit}
                                        autoFocus
                                        // ref={durationInputRef}
                                        label={t(
                                          'views.orderDetails.durationLabel',
                                        )}
                                        fullWidth
                                        type='number'
                                        inputProps={{ min: 0, step: 1 }}
                                        value={
                                          isNaN(editingDuration)
                                            ? ''
                                            : editingDuration
                                        }
                                        onChange={(e) => {
                                          const newValue = Number(
                                            e.target.value,
                                          );
                                          setEditingDuration(
                                            isNaN(newValue) ? 0 : newValue,
                                          );
                                        }}
                                        onFocus={(e) => e.target.select()}
                                        // onBlur={(e) =>
                                        //   handleDurationChangeEnd(e, item._id)
                                        // }
                                        sx={{ maxWidth: '100px' }}
                                      />
                                      <IconButton edge='end' type='submit'>
                                        <CheckIcon color='primary' />
                                      </IconButton>
                                      <Tooltip
                                        title={t(
                                          'views.orderDetails.resetDurationTooltip',
                                        )}
                                      >
                                        <IconButton edge='end' type='reset'>
                                          <Refresh sx={{ color: 'purple' }} />
                                        </IconButton>
                                      </Tooltip>
                                      <IconButton
                                        edge='end'
                                        onClick={() => setIsEditingFile(null)}
                                        type='button'
                                      >
                                        <XIcon color='error' />
                                      </IconButton>
                                    </Box>
                                  ) : (
                                    <>
                                      {enableEdit && (
                                        <Tooltip
                                          title={t(
                                            'views.orderDetails.changeDurationTooltip',
                                          )}
                                        >
                                          <IconButton
                                            sx={{ marginRight: '8px' }}
                                            edge='end'
                                            onClick={() =>
                                              handleIsEditing(item)
                                            }
                                          >
                                            <Edit02Icon color='primary' />
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                      <Tooltip
                                        title={t(
                                          'views.orderDetails.durationTooltip',
                                        )}
                                      >
                                        <ListItemText
                                          primary={renderDuration(
                                            item.duration,
                                          )}
                                          primaryTypographyProps={{
                                            variant: 'caption',
                                          }}
                                          sx={{
                                            marginLeft: 'auto',
                                            width: '30px',
                                            flexGrow: 0,
                                          }}
                                        />
                                      </Tooltip>
                                      {enableEdit && (
                                        <Tooltip
                                          title={t(
                                            'views.orderDetails.removeTooltip',
                                          )}
                                        >
                                          <IconButton
                                            edge='end'
                                            onClick={() =>
                                              deleteContentFromPlaylist({
                                                playlistId: order._id,
                                                contentId: item._id,
                                              })
                                            }
                                          >
                                            <SvgIcon>
                                              <XIcon color='error' />
                                            </SvgIcon>
                                          </IconButton>
                                        </Tooltip>
                                      )}
                                    </>
                                  )}
                                </ListItem>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </List>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            </>
          )}
        </Stack>
        {/* {!openOptionsPanel ? (
          enableEdit && (
            <Button
              onClick={onSync}
              startIcon={
                <SvgIcon>
                  <Refresh />
                </SvgIcon>
              }
              variant="contained">
              {t("components.tableBodies.sync")}
            </Button>
          )
        ) : null} */}
      </Stack>
    </>
  );
};

OrderDetails.propTypes = {
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
  order: PropTypes.object,
};
